export const practiceActions = {

  FETCH_PRACTICE_FAILED: 'FETCH_PRACTICE_FAILED',
  FETCH_PRACTICE_SUCCESS: 'FETCH_PRACTICE_SUCCESS',
  FETCH_PRACTICE_PENDING: 'FETCH_PRACTICE_PENDING',
  LOAD_PRACTICE: 'LOAD_PRACTICE',
  REJECT_PRACTICE: 'REJECT_PRACTICE',


  fetchPracticeFailed: error => ({
    type: practiceActions.FETCH_PRACTICE_FAILED,
    payload: error
  }),

  fetchPracticeSuccess: (practice_id, {data}) => ({
    type: practiceActions.FETCH_PRACTICE_SUCCESS,
    payload: {
      practice: data.item,
      practice_id: practice_id
    }
  }),

  fetchPracticePending: practice_id => ({
    type: practiceActions.FETCH_PRACTICE_PENDING,
    payload: {
      practice_id
    }
  }),

  loadPractice: practice_id => ({
    type: practiceActions.LOAD_PRACTICE,
    payload: {
      practice_id: practice_id
    }
  }),

};


export const practiceRequestActions = {
  failed: practiceActions.fetchPracticeFailed,
  success: practiceActions.fetchPracticeSuccess,
  pending: practiceActions.fetchPracticePending
};
